import type { FindAllTicketSalesResponseType } from 'src/api/generated/touring/types';
import { mapPaginationType } from '../mapPaginationType';
import { mapTicketSalesResultType } from './helpers';
import type { FindAllTicketSalesType } from './types';

export const mapFindAllTicketSalesResponseType = (
  api: FindAllTicketSalesResponseType
): FindAllTicketSalesType => ({
  results: api.data.map(mapTicketSalesResultType),
  pagination: mapPaginationType(api.metadata.pagination),
});
